export default __webpack_public_path__ + "static/media/registration.0f98347f.svg";